import React, { useEffect, useState } from 'react';
import { loadImageFromURL, clearLoadImageTimeouts } from '../util/load-image-from-url';
import { initializeFabricCanvas } from '../util/initialize-fabric-canvas';
import { attachEventListeners, removeEventListeners } from '../util/attach-event-listeners';
import { MenuProvider } from 'react-contexify';
import EditorContextMenu from './EditorContextMenu';
import LoadError from './LoadError';

const Editor = ({imageURL, setEditor, setShowImageLoader, editor, fileName, setImageError }) => {
  const [error, setError] = useState(false);

  const handleError = () => {
    setShowImageLoader(false);
    setError(true);
    setImageError(true);
  };
  useEffect(() => {
    setImageError(false);
    const canvas = global.editor = initializeFabricCanvas();
    attachEventListeners(canvas);
    setEditor(canvas);
    let isMounted = true;
    
    // Handle window resize and zoom changes with throttling
    let resizeRAF = null;
    const handleResize = () => {
      if (resizeRAF) {
        return;
      }
      resizeRAF = requestAnimationFrame(() => {
        resizeRAF = null;
        
        const currentDPR = window.devicePixelRatio || 1;
        if (global.fabric && global.fabric.devicePixelRatio !== currentDPR) {
          global.fabric.devicePixelRatio = currentDPR;
        }

        const bgImage = canvas.backgroundImage;
        if (bgImage) {
          if (!bgImage._originalWidth) {
            bgImage._originalWidth = bgImage.width;
            bgImage._originalHeight = bgImage.height;
          }

          const container = document.querySelector('div.editing-img');
          if (!container) {
            return;
          }
          const containerWidth = container.clientWidth;
          const containerHeight = container.clientHeight;
          if (!containerWidth || !containerHeight) {
            return;
          }
          
          const widthScale = containerWidth / bgImage._originalWidth;
          const heightScale = containerHeight / bgImage._originalHeight;
          const scale = Math.min(widthScale, heightScale) * 0.95; 
          
          bgImage.scaleX = scale;
          bgImage.scaleY = scale;

          const newWidth = bgImage._originalWidth * scale;
          const newHeight = bgImage._originalHeight * scale;

          canvas.setDimensions({ width: newWidth, height: newHeight });
          canvas.requestRenderAll();
        }
      });
    };

    window.addEventListener('resize', handleResize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
    }
    
    loadImageFromURL(imageURL, handleError).then((image) => {
      // Only proceed if component is still mounted
      if (!isMounted) return;
      
      canvas.setBackgroundImage(image, () => {
        canvas.requestRenderAll();
        canvas.setWidth(image.getScaledWidth());
        canvas.setHeight(image.getScaledHeight());
        setShowImageLoader(false);
      }, {
        top: 0,
        left: 0,
        crossOrigin: 'anonymous'
      });
    }).catch(console.error); // TODO: Add Image Error Handler Design in Catch Block.
    
    return () => {
      isMounted = false;
      clearLoadImageTimeouts();
      removeEventListeners(canvas);
      window.removeEventListener('resize', handleResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleResize);
      }
    };
  }, [imageURL, setEditor, setShowImageLoader]);

  if (error) {
    return <LoadError />;
  }

  return (
    <>
      <MenuProvider id="menu_id">
      <div className="editing-img">
        <canvas id="main"></canvas>
      </div>
      </MenuProvider>
      <EditorContextMenu editor={editor} fileName={fileName} />
    </>
  );
};

export default Editor;
